import { Backdrop, Box, Button, CircularProgress, Stack, TextField, Checkbox, Typography, MenuItem, IconButton, FormControlLabel, Select } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Context } from '../../App';
import moment from 'moment';
import { Add, DeleteForever } from '@mui/icons-material';

export default function PromoForm({close, showResult, listEvents, setPromos, promo=null}) {
    const { setIsConnected } = React.useContext(Context);
    
    const [titre, setTitre] = useState(promo?.titre || '');
    const [code, setCode] = useState(promo?.code || '');
    const [reduction, setReduction] = useState(promo?.reduction || 0);
    const [isPercentage, setIsPercentage] = useState(promo?.isPercentage || false);
    const [dateDebut, setDateDebut] = useState(promo?.dateDebut? moment.utc(promo.dateDebut).format('yyyy-MM-DD') : '');
    const [dateFin, setDateFin] = useState(promo?.dateFin ? moment.utc(promo.dateFin).format('yyyy-MM-DD') : '');
    const [limite, setLimite] = useState(promo?.limite || 0);
    const [events, setEvents] = useState(promo?.events || []);
    const [sponsor, setSponsor] = useState(promo?.sponsor || '');
    const [users, setUsers] = useState(promo?.users || []);
    const [listUsers, setListUsers] = useState([]);
    const [conditions, setConditions] = useState(promo?.conditions || []);


    const [loading, setLoading] = useState(false);

    function handleSave(e) {
        e.preventDefault();
        setLoading(true);
        
        const newPromo = {titre, code, reduction, isPercentage, events, sponsor, conditions};
        if(dateDebut&&dateFin) {
            newPromo.dateDebut = dateDebut;
            newPromo.dateFin = dateFin;
        }
        if(limite&&limite>0) {
            newPromo.limite = limite;
        }
        if(users.length > 0) {
            newPromo.users = users;
        }

        const url = process.env.REACT_APP_API_URL.concat(promo?._id ? `/promo?_id=${promo._id}` : '/promo');
        
        fetch(url, {
            method: promo?._id ? 'PATCH':'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            },
            body: JSON.stringify(newPromo),
        }).then(async response => { console.log('response: ', response)
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', token);
                }
                if (response.status === 200) {
                    const json = await response.json();
                    if (json) {
                        setPromos(prev => promo ? prev.map(p => p._id === promo._id ? json : p) : [...prev, json]);
                    }
                    showResult(Boolean(json));
                } else {
                    showResult(false);
                }
            }
        }).catch(error => {
            console.error("Error saving project:", error);
            showResult(false);
        }).finally(() => {
            setLoading(false);
            close(); // Close the form after saving
        });
    }

    useEffect(() => {
        setLoading(true); console.log(promo?.conditions)
        fetch(process.env.REACT_APP_API_URL.concat('/users'), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    setListUsers(json);
                }
            }
        }).catch(error => {
            console.error("Error fetching users:", error);
        }).finally(() => {
            setLoading(false);
        });
    }, [])

    return (
        <Box component={'form'} onSubmit={handleSave} sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding:2, minWidth: '200px' }}>

            <Typography variant='h5' mt={2}>Informations de la réduction</Typography>
            <Stack direction="row" gap={1} flex={1} flexWrap='wrap' alignItems="center">
                <TextField fullWidth variant='standard' label='Titre' value={titre} onChange={(e) => setTitre(e.target.value)} required sx={{minWidth:'200px'}} />
            </Stack>
            <Stack direction="row" gap={1} alignItems="center">
                <TextField fullWidth label='Sponsor' value={sponsor} onChange={(e) => setSponsor(e.target.value)} sx={{minWidth:'200px'}} />
                <TextField type='date' label='Date de début' slotProps={{inputLabel:{ shrink: true} }} value={dateDebut} onChange={(e) => setDateDebut(e.target.value)} sx={{minWidth:'200px'}} />
                <TextField type='date' label='Date de fin' slotProps={{inputLabel:{ shrink: true} }} value={dateFin} onChange={(e) => setDateFin(e.target.value)} sx={{minWidth:'200px'}} />
            </Stack>

            <Stack direction="row" gap={1} alignItems="center">
                <TextField type='number' label="Réduction" value={reduction} required
                onChange={(e) => setReduction(prev => e.target.value>=0 ? e.target.value : e.target.value*-1)} 
                onFocus={()=> setReduction(prev=> prev<=0 ? '' : prev)} 
                onBlur={()=> setReduction(prev=>prev==='' || prev < 0 ? 0 : prev)}
                slotProps={{htmlInput: {min: 0, step: isPercentage ? 1 : 1}}}
                sx={{minWidth:'200px'}}/>
                <FormControlLabel control={<Checkbox checked={isPercentage} onChange={(e) => setIsPercentage(e.target.checked)} />} label="Pourcentage" />
                <TextField type='number' label="Limite d'utilisation" value={limite} 
                onChange={(e) => setLimite(prev => e.target.value>=0 ? e.target.value : e.target.value*-1)} 
                onFocus={()=> setLimite(prev=> prev<=0 ? '' : prev)} 
                onBlur={()=> setLimite(prev=>prev==='' || prev < 0 ? 0 : prev)}
                slotProps={{htmlInput: {min: 0, step: 1}}}
                sx={{minWidth:'200px'}} />
            </Stack>

            <Stack direction="row" gap={1} alignItems="center">
                <TextField fullWidth label='Code' value={code} onChange={(e) => setCode(e.target.value)} sx={{minWidth:'200px'}} />
                <TextField fullWidth select label='Utilisateurs' slotProps={{inputLabel: {shrink: true}}} value={users} onChange={(e) => setUsers(e.target.value)} sx={{minWidth:'300px'}}>
                    {listUsers.map((user, index) => (
                        <MenuItem key={index} value={user._id}>{user.nom} {user.prenom} ({user.mail})</MenuItem>
                    ))}
                </TextField>
            </Stack>

            <Typography variant='h5' mt={2}>Évènements associés</Typography>
            <Stack direction="row" gap={1} alignItems="center">
                <Select select multiple required label='Évènements' slotProps={{inputLabel: {shrink: true}, native: true}} value={events} onChange={(e) => setEvents(e.target.value)} sx={{minWidth:'300px'}}>
                    {listEvents.map((event, index) => (
                        <MenuItem key={index} value={event._id}>{event.titre}</MenuItem>
                    ))}
                </Select>
                <Button variant="outlined" onClick={() => setEvents([])}>Désélectionner</Button>
                <Button variant="outlined" onClick={() => setEvents(listEvents.map(event => event._id))}>Sélectionner tous</Button>
            </Stack>

            <Typography variant='h5' mt={2}>Conditions d'éligibilité</Typography>
            <Stack direction="column" gap={1}>
                {conditions.map((cond, index) => (
                    <Stack key={index} direction="row" gap={1} alignItems="center">
                        <TextField
                            select label="Type" value={cond.type} required
                            onChange={(e) => setConditions(old => old.map((c, i) => i === index ? { ...c, type: e.target.value } : c))}
                            sx={{ minWidth: 240 }}
                        >
                            <MenuItem value="min_billets">Nombre minimum de billets</MenuItem>
                            <MenuItem value="min_montant">Montant minimum d'achat (€)</MenuItem>
                            <MenuItem value="min_prix_billet">Prix minimum du billet (€)</MenuItem>
                        </TextField>
                        <TextField
                            type="number" label="Valeur" value={cond.valeur} required
                            onChange={(e) => setConditions(old => old.map((c, i) => i === index ? { ...c, valeur: Number(e.target.value) } : c))}
                            onFocus={() => setConditions(old => old.map((c, i) => i === index && c.valeur === 0 ? { ...c, valeur: '' } : c))}
                            onBlur={() => setConditions(old => old.map((c, i) => i === index && (c.valeur === '' || c.valeur < 0) ? { ...c, valeur: 0 } : c))}
                            slotProps={{ htmlInput: { min: 0, step: 1 } }}
                            sx={{ width: 120 }}
                        />
                        <IconButton onClick={() => setConditions(old => old.filter((_, i) => i !== index))} aria-label="supprimer la condition">
                            <DeleteForever />
                        </IconButton>
                    </Stack>
                ))}
                <Button
                    variant="outlined" startIcon={<Add />} onClick={() => setConditions(old => [...old, { type: 'min_billets', valeur: 1 }])}
                    sx={{ alignSelf: 'flex-start', mt: 1 }}
                >
                    Ajouter une condition
                </Button>
            </Stack>
            
            <Stack direction="row" spacing={2} alignItems="center" justifyContent={'flex-end'}>
                <Button variant="outlined" onClick={close}>annuler</Button>
                <Button variant="contained" color="primary" type="submit" disabled={loading}>
                    {loading && <CircularProgress size={24} />} Enregistrer
                </Button>
            </Stack>

            <Backdrop open={loading}><CircularProgress/></Backdrop>
        </Box>
    );
}